// Map to 2025 design token values
const lightColors = {
  colorNeutral: 'hsl(219, 12%, 42%)',
  colorPrimary: 'hsl(212, 94%, 42%)',
  colorSecondary: 'hsl(329,60%,30%)',
  colorAlert: 'hsl(0, 100%, 36%)',
  colorWarning: 'hsl(43, 89%, 39%)',
  colorSuccess: 'hsl(123, 46%, 36%)',
  colorInfo: 'hsl(212, 94%, 36%)',
  colorStatusNeutral: 'hsl(219, 12%, 36%)',
  colorUiLight: 'hsl(219, 0%, 100%)',
  colorUiMedium: 'hsl(219, 12%, 98%)',
  colorUiDark: 'hsl(219, 12%, 96%)',
  colorUiBorder: 'hsl(219, 12%, 88%)',
  colorUiPop: 'hsl(212, 94%, 42%)',
  colorTextDefault: 'hsl(219, 12%, 12%)',
  colorTextLabel: 'hsl(219, 12%, 48%)',
  colorTextInverse: 'hsl(219, 0%, 100%)',
  colorTextPrimary: 'hsl(212, 94%, 42%)',
  colorTextSecondary: 'hsl(329,60%,30%)',
  colorTextPop: 'hsl(212, 0%, 100%)',
  colorGraph1: '#33a3ff',
  colorGraph2: '#ffcc33',
  colorGraph3: '#9470ff',
  colorGraph4: '#ff8324',
  colorGraph5: '#29d1d1',
  colorGraph6: '#dc5656',
  colorGraph7: '#15b77b',
  colorGraph8: '#ff70bc',
  colorKPI1: '#dd5757',
  colorKPI3: '#ffcc32',
  colorKPI5: '#15b57b'
};
const darkColors = {
  colorNeutral: 'hsl(219, 12%, 64%)',
  colorPrimary: 'hsl(212, 94%, 62%)',
  colorSecondary: 'hsl(329,60%,40%)',
  colorAlert: 'hsl(0, 100%, 64%)',
  colorWarning: 'hsl(43, 89%, 64%)',
  colorSuccess: 'hsl(123, 46%, 63%)',
  colorInfo: 'hsl(212, 94%, 62%)',
  colorStatusNeutral: 'hsl(219, 12%, 64%)',
  colorUiLight: 'hsl(219, 12%, 17%)',
  colorUiMedium: 'hsl(219, 12%, 12%)',
  colorUiDark: 'hsl(219, 12%, 8%)',
  colorUiBorder: 'hsl(219, 12%, 30%)',
  colorUiPop: 'hsl(212, 94%, 36%)',
  colorTextDefault: 'hsl(219, 12%, 88%)',
  colorTextLabel: 'hsl(219, 12%, 59%)',
  colorTextInverse: 'hsl(219, 12%, 12%)',
  colorTextPrimary: 'hsl(212, 94%, 62%)',
  colorTextSecondary: 'hsl(329,60%,30%)',
  colorTextPop: 'hsl(212, 0%, 100%)',
  colorGraph1: '#2470ad',
  colorGraph2: '#98863c',
  colorGraph3: '#5954ad',
  colorGraph4: '#985b30',
  colorGraph5: '#238a92',
  colorGraph6: '#84414b',
  colorGraph7: '#17785f',
  colorGraph8: '#985186',
  colorKPI1: '#84414b',
  colorKPI3: '#98863c',
  colorKPI5: '#17785f'
};
const highContrastColors = {
  colorNeutral: 'hsl(219, 12%, 84%)',
  colorPrimary: 'hsl(212, 94%, 83%)',
  colorSecondary: 'hsl(329,60%,57%)',
  colorAlert: 'hsl(0, 100%, 84%)',
  colorWarning: 'hsl(43, 89%, 84%)',
  colorSuccess: 'hsl(123, 46%, 82%)',
  colorInfo: 'hsl(212, 94%, 83%)',
  colorStatusNeutral: 'hsl(219, 12%, 84%)',
  colorUiLight: 'hsl(219, 0%, 0%)',
  colorUiMedium: 'hsl(219, 0%, 0%)',
  colorUiDark: 'hsl(219, 0%, 0%)',
  colorUiBorder: 'hsl(219, 0%, 100%)',
  colorUiPop: 'hsl(212, 94%, 35%)',
  colorTextDefault: 'hsl(219, 0%, 100%)',
  colorTextLabel: 'hsl(219, 0%, 100%)',
  colorTextInverse: 'hsl(219, 0%, 0%)',
  colorTextPrimary: 'hsl(212, 94%, 83%)',
  colorTextSecondary: 'hsl(329, 60%, 62%)',
  colorTextPop: 'hsl(212, 0%, 100%)',
  colorGraph1: '#4aacff',
  colorGraph2: '#f1d700',
  colorGraph3: '#c68aff',
  colorGraph4: '#f98e39',
  colorGraph5: '#00d692',
  colorGraph6: '#ff817a',
  colorGraph7: '#7cbf00',
  colorGraph8: '#ff6fbd',
  colorKPI1: '#ff5e4d',
  colorKPI3: '#f2d94b',
  colorKPI5: '#7bb04a'
};
const colors = {
  neutral: '#768396',
  primary: '#0378cd',
  secondary: '#86134f',
  alert: '#d80000',
  warning: '#916000',
  success: '#0a7c12',
  information: '#016DBA'
};
export const LightThemeParameters = {
  baseThemeName: 'light',
  colors: {
    ...colors,
    ...lightColors
  },
  enableNovaTokens: false
};
export const DarkThemeParameters = {
  ...LightThemeParameters,
  colors: {
    ...LightThemeParameters.colors,
    ...darkColors
  },
  baseThemeName: 'dark'
};
export const HighContrastThemeParameters = {
  ...LightThemeParameters,
  baseThemeName: 'high-contrast',
  colors: {
    ...LightThemeParameters.colors,
    secondary: '#EA6CAD',
    alert: '#ff6347',
    warning: '#daa520',
    success: '#32cd32',
    information: '#22a7f0',
    ...highContrastColors
  }
};
export const defaultThemes = {
  light: LightThemeParameters,
  dark: DarkThemeParameters,
  'high-contrast': HighContrastThemeParameters
};

/**
 * SAS system application theme's theme parameters.
 */
export const ApplicationThemeParametersMap = {
  sas_corporate: {
    baseThemeName: 'light',
    colors: {
      ...colors,
      ...lightColors
    }
  },
  sas_ignite: {
    baseThemeName: 'dark',
    colors: {
      ...colors,
      ...darkColors
    }
  },
  sas_hcb: {
    baseThemeName: 'high-contrast',
    colors: {
      ...colors,
      secondary: '#EA6CAD',
      alert: '#ff6347',
      warning: '#daa520',
      success: '#32cd32',
      information: '#22a7f0',
      ...highContrastColors
    }
  }
};

/**
 * SAS system report theme's theme parameters.
 */
export const ReportThemeParametersMap = {
  marine: {
    baseThemeName: 'light',
    colors: {
      neutral: '#828282',
      primary: '#4e4e4e',
      secondary: '#4e4e4e',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  midnight: {
    baseThemeName: 'dark',
    colors: {
      neutral: '#fff',
      primary: '#0378cd',
      secondary: '#0378cd',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  midnight2020: {
    baseThemeName: 'dark',
    colors: {
      neutral: '#fff',
      primary: '#0378cd',
      secondary: '#0378cd',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  opal: {
    baseThemeName: 'light',
    colors: {
      neutral: '#768396',
      primary: '#3c444f',
      secondary: '#3c444f',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  // NOTE: Aqua and sail are the same theme
  // https://rndconfluence.sas.com/confluence/pages/viewpage.action?pageId=92737303#OpenUIReport&GraphWorkflowDocumentation-ReportThemes
  sail: {
    baseThemeName: 'light',
    colors: {
      neutral: '#828282',
      primary: '#4e4e4e',
      secondary: '#4e4e4e',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#0072b2'
    }
  },
  aqua: {
    baseThemeName: 'light',
    colors: {
      neutral: '#828282',
      primary: '#4e4e4e',
      secondary: '#4e4e4e',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#0072b2'
    }
  },
  umstead: {
    baseThemeName: 'light',
    colors: {
      neutral: '#828282',
      primary: '#4e4e4e',
      secondary: '#4e4e4e',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  // highcontrast2020 uses the new theme 2025 design tokens
  highcontrast2020: {
    baseThemeName: 'high-contrast',
    colors: {
      neutral: '#5e6778',
      primary: '#0664d0',
      secondary: '#7a1f4e',
      alert: '#ffadad',
      warning: '#fbe6b2',
      success: '#bce6be',
      information: '#abd1fc'
    }
  },
  // highcontrast2018 and highcontrast2017 should receive the same treatment
  highcontrast2018: {
    baseThemeName: 'high-contrast',
    colors: {
      neutral: '#fff',
      primary: '#44affc',
      secondary: '#ea6cad',
      alert: '#ff6347',
      warning: '#daa520',
      success: '#32cd32',
      information: '#22a7f0'
    }
  },
  highcontrast2017: {
    baseThemeName: 'high-contrast',
    colors: {
      neutral: '#fff',
      primary: '#98fb98',
      secondary: '#0ff',
      alert: '#ff6347',
      warning: '#daa520',
      success: '#32cd32',
      information: '#22a7f0'
    }
  },
  // Legacy
  light: {
    baseThemeName: 'light',
    colors: {
      neutral: '#768396',
      primary: '#0378cd',
      secondary: '#287eab',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  dark: {
    baseThemeName: 'dark',
    colors: {
      neutral: '#768396',
      primary: '#0378cd',
      secondary: '#287eab',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  snow: {
    baseThemeName: 'light',
    colors: {
      neutral: '#768396',
      primary: '#0378cd',
      secondary: '#287eab',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  highcontrast: {
    baseThemeName: 'high-contrast',
    colors: {
      neutral: '#ffffff',
      primary: '#00fffc',
      secondary: '#00fffc',
      alert: '#d80000',
      warning: '#916000',
      success: '#0a7c12',
      information: '#016dba'
    }
  },
  light2025: {
    baseThemeName: 'light',
    colors: {
      neutral: '#5e6778',
      primary: '#0664d0',
      secondary: '#7a1f4e',
      alert: '#b80000',
      warning: '#bc8a0b',
      success: '#328636',
      information: '#0656b2'
    }
  },
  dark2025: {
    baseThemeName: 'dark',
    colors: {
      neutral: '#5e6778',
      primary: '#0664d0',
      secondary: '#7a1f4e',
      alert: '#ff4747',
      warning: '#f5c751',
      success: '#75cc7a',
      information: '#4398f9'
    }
  }
};

/**
 * SAS system theme's (application and report themes) theme parameters.
 */
export const ThemeIdMap = {
  ...ReportThemeParametersMap,
  ...ApplicationThemeParametersMap
};
//# sourceMappingURL=themeParameters.js.map